import { Injectable } from '@angular/core';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { ApplicationAccessControlFullFindInterface } from '@zaoblako/shared/modules/security/dtos/application/access-control/application-access-control-full-find.dto';
import type { ApplicationAccessControlRoleFormInterface } from '@zaoblako/shared/modules/security/dtos/application/access-control/application-access-control-role-form.dto';
import type { RoleRegistryQueryInterface } from '@zaoblako/shared/modules/security/dtos/role/role-registry-query.dto';
import type { RoleRegistryPageInterface } from '@zaoblako/shared/modules/security/dtos/role/role-registry-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService extends BaseService {
  protected baseUrl = '/basis/security/role';

  public get dropdownDescriptorUrl() {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findRegistryPage(params?: RoleRegistryQueryInterface): Observable<RoleRegistryPageInterface> {
    return this.http.get<RoleRegistryPageInterface>(`${this.baseUrl}/items`, {
      params: params ? this.objectToHttpParams(params) : {}
    });
  }

  public accessControlGet(id: number): Observable<ApplicationAccessControlFullFindInterface> {
    return this.http.get<ApplicationAccessControlFullFindInterface>(`${this.baseUrl}/${id}/access-control`);
  }

  public accessControlPut(id: number, body: ApplicationAccessControlRoleFormInterface): Observable<ApplicationAccessControlFullFindInterface> {
    return this.http.put<ApplicationAccessControlFullFindInterface>(`${this.baseUrl}/${id}/access-control`, body);
  }
}
